/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['[_nghost-%COMP%]{display:block}.route-control[_ngcontent-%COMP%]{margin-top:20px;margin-bottom:20px;text-align:center}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL21hcC9tYXAuY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9rc21haS93ZWJkZXYvYWRtaW4tdGVtcGxhdGUvc3JjL2FwcC9zaGFyZWQvbWFwL21hcC5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./$$_gendir/src/app/shared/map/map.component.scss.shim.ngstyle.ts